/**
 * UUID v4 одной строкой на все три платформы.
 *
 * `crypto.randomUUID` есть в вебе и в новых движках, но не в Hermes любой сборки, поэтому нужен
 * запасной путь. Он на `Math.random`, и это осознанно: идентификаторы, которые здесь генерятся
 * (нога звонка, событие аналитики), никого не аутентифицируют — им нужна уникальность, а не
 * непредсказуемость.
 */
export function randomUuid(): string {
  const c = globalThis.crypto;
  if (c && typeof c.randomUUID === 'function') {
    return c.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (ch) => {
    const r = (Math.random() * 16) | 0;
    const v = ch === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
